import React from "react";

const JQuery_Syllabus = () => {
  return (
    <div>
      <h1>JQuery_Syllabus</h1>
      <p>Placeholder component for: "JQuery_Syllabus"</p>
    </div>
  );
};

export default JQuery_Syllabus;
